var map = {
	"./AboutUs/appletImg.png": 51885,
	"./AboutUs/bannerAboutUs.png": 55999,
	"./AboutUs/officialAccountImg.png": 90836,
	"./AboutUs/ourMissionImg.png": 96068,
	"./AboutUs/ourVisionImg.png": 58387,
	"./CoreCompetence/CoreCompetenceMapImg.png": 13758,
	"./CoreCompetence/ProfessionalTraining.png": 14572,
	"./CoreCompetence/advancedTechnique.png": 48282,
	"./CoreCompetence/bannerCoreCompetence.png": 48123,
	"./CoreCompetence/bannerCoreCompetence_2.png": 91711,
	"./CoreCompetence/bannerCoreCompetence_3.png": 4098,
	"./CoreCompetence/custodyBg.png": 81051,
	"./CoreCompetence/goodService.png": 66658,
	"./DisabilityImg.png": 12655,
	"./EnvironmentalTransformationImg.png": 22686,
	"./HealthGuardianBg.png": 72073,
	"./IntelligentPensionImg.png": 22029,
	"./PensionInstitutionsImg.png": 75311,
	"./ServiceCapability/bannerServiceCapability.png": 29484,
	"./ServiceCapability/bannerServiceCapability_2.png": 13744,
	"./ServiceCapability/bannerServiceCapability_3.png": 99879,
	"./ServiceCapability/emergencyResponseImg.png": 20083,
	"./ServiceCapability/emergencyResponseImg_1.png": 41646,
	"./ServiceCapability/img_1.png": 20745,
	"./ServiceCapability/img_1L.png": 19616,
	"./ServiceCapability/img_2.png": 44176,
	"./ServiceCapability/img_2L.png": 77281,
	"./ServiceCapability/img_3.png": 966,
	"./ServiceCapability/img_3L.png": 46867,
	"./ServiceCapability/img_4.png": 9401,
	"./ServiceCapability/img_4L.png": 4665,
	"./ServiceCapability/img_5.png": 59255,
	"./ServiceCapability/img_5L.png": 28615,
	"./ServiceCapability/left.png": 47937,
	"./ServiceCapability/pensionEquipmentImg.png": 23132,
	"./ServiceCapability/pensionPlatformImg.png": 98165,
	"./ServiceCapability/radarImg.png": 79492,
	"./ServiceCapability/right.png": 10962,
	"./ServiceCapability/serviceContentImg.png": 34745,
	"./ServiceCapability/serviceContentImg_2.png": 11280,
	"./ServiceCapability/serviceContentImg_3.png": 56685,
	"./ServiceCapability/serviceContentImg_4.png": 19584,
	"./ServiceCapability/sosImg.png": 91062,
	"./Solution/bannerSolution.png": 46979,
	"./Solution/bannerSolution_2.png": 73613,
	"./Solution/bannerSolution_3.png": 24728,
	"./Solution/flagIcon.png": 22748,
	"./Telephone.png": 96625,
	"./VeteranHealthImg.png": 70488,
	"./applicableScenarioBg.png": 93293,
	"./applicableScenarioItebg.png": 43553,
	"./benefitOneImg.png": 34677,
	"./benefitThImg.png": 67187,
	"./benefitTwoImg.png": 81931,
	"./cardiovascularImg.png": 54724,
	"./digitizationChart.png": 4521,
	"./emergencyImg.png": 1707,
	"./employeeWelfareImg.png": 60917,
	"./environmentalTransformation.png": 27176,
	"./fallImg.png": 62132,
	"./healthCareBg.png": 20670,
	"./healthMonitoring.png": 58984,
	"./healthRisksbg.png": 81347,
	"./home/downloadApk.png": 15666,
	"./home/ykyh_logo.png": 47411,
	"./homebannerOne.png": 54554,
	"./homebannerOne_2.png": 69757,
	"./homebannerOne_3.png": 64393,
	"./homehealthmonitoringImg.png": 62547,
	"./innutritionImg.png": 74941,
	"./logo.png": 66949,
	"./logoIcon.png": 31444,
	"./logotransparent.png": 13972,
	"./nursingInstitutionsImg.png": 8236,
	"./riskButtonbg.png": 45532,
	"./securityImg.png": 96649,
	"./valueAddedImg.png": 58292,
	"./videobg.png": 15540,
	"./weakImg.png": 25932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92715;